import { render, staticRenderFns } from "./SystemUpdate.vue?vue&type=template&id=60d07191&scoped=true&"
import script from "./SystemUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SystemUpdate.vue?vue&type=style&index=0&id=60d07191&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d07191",
  null
  
)

export default component.exports